export default __webpack_public_path__ + "static/media/greatnews-create.b06d74a9.svg";